/* Name necklace picker with a live gold / silver font preview (replaces the Zepto personalizer on name necklaces).
   - Font: the theme's Font buttons are swapped for the font names alone; shoppers tap through them and watch the
     preview change. A tap ticks the theme's own (hidden) Font button, so the variant, price, SKU and photos change
     exactly as before.
   - Preview: only the name or word, in the chosen font, as polished gold or silver on a deep espresso ground, with the
     typing bar joined underneath (so the preview stays in view above the phone keyboard). It shows the font, not the
     finished piece (the note under it says so). It is drawn in the shopper's browser only, never saved as product
     media, so product feeds, catalogs and Meta ads never see it.
   - Finish stays on the theme's own buttons; the preview follows it (18K Gold or Silver), and so do the birthstone settings.
   - Birthstone / birth flower (on the products that have one): a slim row that opens to the choices and folds once one
     is chosen, like the Eliora Necklace. The choices themselves come from the shared snippets, not from this file.
   - Order properties: the name under the key from the snippet ("Personalization"), each choice under its own key
     ("Birthstone", "Birth Flower"), and _pplr_customization_id (empty), as Zepto sent but without its trailing colons. */
(function () {
  'use strict';
  var root = document.querySelector('[data-eenp]');
  if (!root || root.__eenp) return;
  root.__eenp = true;

  var CFG = JSON.parse(root.getAttribute('data-cfg'));
  var KEY = CFG.key, MAX = CFG.max || 9, SAMPLE = CFG.sample || 'Your Name', SCALE = CFG.scale || {};
  function fscale(v) { return SCALE[v] || 1; }   // some fonts draw small or large for their size (Gilded Grace's lowercase is tiny)
  document.documentElement.classList.add('eenp-on');   // hides the theme's own Font row

  var q = function (s) { return root.querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var inp = q('[data-eenp-input]'), countEl = q('[data-eenp-count]'), noteEl = q('[data-eenp-note]'), errEl = q('[data-eenp-err]'),
      fontLab = q('[data-eenp-fontname]'), stage = q('[data-eenp-stage]'), cv = q('[data-eenp-canvas]');
  var rows = $$('[data-eenp-font]', root);   // the font name buttons
  var NOTE = noteEl ? noteEl.textContent : '';

  var S = { name: '', font: CFG.font };

  /* ---------- the theme's option buttons ---------- */
  function fieldset(h) { return document.querySelector('fieldset[data-handle="' + h + '"]'); }
  function checked(h) { var f = fieldset(h), r = f && f.querySelector('input:checked'); return r ? r.value : null; }
  function finishValue() { return checked(CFG.finishOpt) || CFG.finish || ''; }
  function metal() { return /silver|white|platinum/i.test(finishValue()) ? 'silver' : 'gold'; }
  function family(v) { return CFG.families[v] || CFG.families[CFG.font]; }
  function syncTheme(v) {
    var f = fieldset(CFG.fontOpt); if (!f) return;
    var r = $$('input[type="radio"]', f).filter(function (i) { return i.value === v; })[0];
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  /* ---------- the name box ---------- */
  function clean(v) {
    v = String(v || '');
    if (v.normalize) v = v.normalize('NFD').replace(/[̀-ͯ]/g, '');   // accented letters become plain ones (not every font has accents)
    return v.replace(/[^A-Za-z &]/g, '').replace(/ {2,}/g, ' ').replace(/^ +/, '');
  }
  function finalName() { return S.name.replace(/ +$/, ''); }
  var noteT;
  function hint(msg) {
    if (!noteEl) return;
    clearTimeout(noteT);
    noteEl.textContent = msg || NOTE; noteEl.classList.toggle('is-hint', !!msg);
    if (msg) noteT = setTimeout(function () { noteEl.textContent = NOTE; noteEl.classList.remove('is-hint'); }, 4500);
  }
  inp.maxLength = MAX;
  inp.addEventListener('input', function () {
    var raw = inp.value, pos = inp.selectionStart == null ? raw.length : inp.selectionStart;
    var all = clean(raw), v = all.slice(0, MAX);
    var plain = raw.normalize ? raw.normalize('NFD').replace(/[̀-ͯ]/g, '') : raw;
    if (/[^A-Za-z &]/.test(plain)) hint('Letters only, please (A to Z).');
    else if (all.length > MAX) hint('Up to ' + MAX + ' characters fit on this ' + (CFG.item || 'piece') + '.');
    if (v !== raw) {
      var at = Math.min(clean(raw.slice(0, pos)).length, v.length);
      inp.value = v;
      try { inp.setSelectionRange(at, at); } catch (e) {}
    }
    S.name = v;
    if (finalName()) { errEl.hidden = true; root.classList.remove('is-invalid'); }
    update();
  });
  inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
  inp.addEventListener('blur', function () { if (S.name !== finalName()) { S.name = finalName(); inp.value = S.name; update(); } });

  /* ---------- the font names ---------- */
  function markRows() {
    rows.forEach(function (b) {
      var on = b.getAttribute('data-eenp-font') === S.font;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    if (fontLab) fontLab.textContent = S.font;
  }
  function pick(v, focus) {
    if (!v || !CFG.families[v]) return;
    S.font = v; markRows(); syncTheme(v); draw();
    if (focus) { var b = rows.filter(function (c) { return c.getAttribute('data-eenp-font') === v; })[0]; if (b) b.focus(); }
  }
  rows.forEach(function (b, i) {
    b.addEventListener('click', function () { pick(b.getAttribute('data-eenp-font')); });
    b.addEventListener('keydown', function (e) {
      var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return;
      e.preventDefault(); pick(rows[(i + d + rows.length) % rows.length].getAttribute('data-eenp-font'), true);
    });
  });

  /* ---------- birthstone / birth flower: a slim row that opens to the choices, folded once one is chosen ---------- */
  var picks = $$('[data-eenp-pick]', root).map(function (el) {
    var P = {
      el: el, key: el.getAttribute('data-key'), noun: el.getAttribute('data-noun') || 'option', value: '',
      head: el.querySelector('[data-eenp-pick-head]'), panel: el.querySelector('[data-eenp-pick-panel]'),
      text: el.querySelector('[data-eenp-pick-text]'), dot: el.querySelector('[data-eenp-pick-dot]'),
      img: el.querySelector('[data-eenp-pick-img]'), err: el.querySelector('[data-eenp-pick-err]'),
      opts: $$('[data-eenp-opt]', el)
    };
    P.empty = P.text ? P.text.textContent : '';
    return P;
  });
  function current(P) { return P.opts.filter(function (o) { return o.getAttribute('data-value') === P.value; })[0] || null; }
  function setOpen(P, open) {
    P.el.classList.toggle('is-open', open);
    P.head.setAttribute('aria-expanded', open ? 'true' : 'false');
    P.panel.hidden = !open;
  }
  function drawPick(P) {
    var cur = current(P);
    P.el.classList.toggle('is-empty', !cur);
    P.text.textContent = cur ? cur.getAttribute('data-name') : P.empty;
    P.opts.forEach(function (o) { o.setAttribute('aria-pressed', o === cur ? 'true' : 'false'); });
    var pos = cur && cur.getAttribute('data-pos');            // a stone: its spot on the picture strip
    P.dot.style.backgroundPosition = pos || '';
    if (P.img) {                                             // a flower: its drawing, small
      var src = cur && cur.querySelector('img') ? cur.querySelector('img').getAttribute('src') : '';
      if (src) { if (P.img.getAttribute('src') !== src) P.img.setAttribute('src', src); P.img.hidden = false; } else P.img.hidden = true;
    }
  }
  function pickError(P, msg) {
    if (!P.err) return;
    P.err.textContent = msg || ''; P.err.hidden = !msg; P.el.classList.toggle('is-invalid', !!msg);
  }
  /* when a row opens near the bottom of the screen, bring its choices into view */
  function reveal(el) {
    requestAnimationFrame(function () {
      var b = el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      var top = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) + 8;
      if (b.bottom > vh - 12) window.scrollTo({ top: Math.max(0, Math.min(b.top + window.pageYOffset - top, b.bottom + window.pageYOffset - vh + 24)), behavior: 'smooth' });
    });
  }
  picks.forEach(function (P) {
    P.head.addEventListener('click', function () {
      var open = !P.el.classList.contains('is-open');
      setOpen(P, open);
      if (open) reveal(P.el);
    });
    P.opts.forEach(function (o) {
      o.addEventListener('click', function () {
        P.value = o.getAttribute('data-value');
        drawPick(P); pickError(P, ''); setOpen(P, false); syncProps();
      });
    });
    drawPick(P);
  });

  /* ---------- line-item properties inside the real product form ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="' + CFG.finishOpt + '"] input[type="radio"], fieldset[data-handle="' + CFG.fontOpt + '"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    var box = form.querySelector('[data-eenp-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-eenp-props', ''); box.hidden = true; form.appendChild(box); }
    var n = finalName(), list = n ? [[KEY, n]] : [];
    picks.forEach(function (P) { if (P.value) list.push([P.key, P.value]); });
    if (list.length) list.push(['_pplr_customization_id', '']);
    var sig = JSON.stringify(list);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    box.innerHTML = '';
    list.forEach(function (r) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[' + r[0] + ']'; h.value = r[1];
      box.appendChild(h);
    });
  }
  /* Zepto's own box (if the app still injects one) is removed, so it can't add a second, empty entry to the order
     (its names, with or without the trailing colon, are cleared from the form too) */
  var ZKEYS = [KEY].concat(picks.map(function (P) { return P.key; }), ['_pplr_customization_id']);
  var ZSEL = ZKEYS.map(function (k) {
    k = String(k).replace(/:+$/, '');
    return ['input', 'textarea', 'select'].map(function (t) { return t + '[name="properties[' + k + ']"],' + t + '[name="properties[' + k + ':]"]'; }).join(',');
  }).join(',');
  function unzep() {
    $$('.product-personalizer').forEach(function (e) { e.parentNode.removeChild(e); });
    $$(ZSEL).forEach(function (i) {
      if (!i.closest('[data-eenp-props]')) i.parentNode.removeChild(i);
    });
  }

  /* ---------- the preview: the name or word alone, as polished metal ---------- */
  var PAL = {
    gold: {
      face: [[0, '#fff1c6'], [0.22, '#efd38a'], [0.48, '#cfa04a'], [0.62, '#f2da98'], [0.84, '#d9b05a'], [1, '#ad8233']],
      edge: '#7d5c1f', shadow: 'rgba(0,0,0,.5)', hi: 'rgba(255,250,228,.95)', lo: 'rgba(92,64,20,.6)', sheen: 'rgba(255,252,236,.65)'
    },
    silver: {
      face: [[0, '#ffffff'], [0.22, '#eef0f3'], [0.48, '#b3b9c1'], [0.62, '#f4f5f7'], [0.84, '#ccd0d6'], [1, '#959aa2']],
      edge: '#5f646b', shadow: 'rgba(0,0,0,.5)', hi: 'rgba(255,255,255,.98)', lo: 'rgba(62,66,74,.55)', sheen: 'rgba(255,255,255,.7)'
    }
  };
  var ctx = cv.getContext('2d');
  var W = 0, H = 0, DPR = 1;
  var mctx = document.createElement('canvas').getContext('2d');
  var face = document.createElement('canvas'), fctx = face.getContext('2d');
  var rim = document.createElement('canvas'), rctx = rim.getContext('2d');

  function setup() {
    var w = Math.round(stage.clientWidth); if (!w) return false;
    var h = Math.round(Math.max(150, Math.min(200, w * 0.46)));
    var d = Math.min(window.devicePixelRatio || 1, 2.5);
    if (w === W && h === H && d === DPR) return true;
    W = w; H = h; DPR = d;
    cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR); cv.style.height = H + 'px';
    face.width = rim.width = cv.width; face.height = rim.height = cv.height;
    return true;
  }
  /* the name sits in the middle: letters a set height, smaller only when a long name needs the room */
  function layout(text, fam, sc) {
    mctx.font = '100px "' + fam + '"';
    var capM = mctx.measureText('H'), m = mctx.measureText(text);
    var capA = capM.actualBoundingBoxAscent || 70;
    var L = m.actualBoundingBoxLeft || 0, R = m.actualBoundingBoxRight || m.width, A = m.actualBoundingBoxAscent || capA, D = m.actualBoundingBoxDescent || 25;
    var px = H * 0.31 / capA * 100 * (sc || 1);
    px = Math.min(px, W * 0.8 / (L + R) * 100, H * 0.64 / (A + D) * 100);
    var k = px / 100;
    var x = W / 2 - (R - L) / 2 * k;
    var cy = H * 0.56;
    var y = cy + (A - D) / 2 * k;
    return { px: px, cap: capA * k, x: x, y: y, ink: { l: x - L * k, r: x + R * k, t: y - A * k, b: y + D * k } };
  }
  /* a lit rim on one side of every letter: the letters, minus the same letters nudged the other way */
  function rimLayer(text, Lo, font, color, dx, dy) {
    rctx.setTransform(1, 0, 0, 1, 0, 0); rctx.globalCompositeOperation = 'source-over'; rctx.clearRect(0, 0, rim.width, rim.height);
    rctx.setTransform(DPR, 0, 0, DPR, 0, 0); rctx.font = font; rctx.textBaseline = 'alphabetic';
    rctx.fillStyle = color; rctx.fillText(text, Lo.x, Lo.y);
    rctx.globalCompositeOperation = 'destination-out'; rctx.fillStyle = '#000'; rctx.fillText(text, Lo.x + dx, Lo.y + dy);
    fctx.save(); fctx.setTransform(1, 0, 0, 1, 0, 0); fctx.globalCompositeOperation = 'source-atop'; fctx.drawImage(rim, 0, 0); fctx.restore();
  }
  /* polished metal letters: a soft shadow, a little thickness, a graded face with a sheen, lit and shaded rims */
  function plate(text, fam, Lo, pal) {
    var font = Lo.px + 'px "' + fam + '"', t = Lo.ink.t, b = Lo.ink.b;
    var th = Math.max(0.8, Lo.cap * 0.032), bw = Math.max(0.55, Lo.cap * 0.02);
    ctx.save();
    ctx.font = font; ctx.textBaseline = 'alphabetic';
    ctx.shadowColor = pal.shadow; ctx.shadowBlur = Math.max(3, Lo.cap * 0.16) * DPR;
    ctx.shadowOffsetX = Lo.cap * 0.02 * DPR; ctx.shadowOffsetY = Lo.cap * 0.07 * DPR;
    ctx.fillStyle = pal.edge; ctx.fillText(text, Lo.x, Lo.y + th);
    ctx.shadowColor = 'transparent';
    for (var i = th - 0.4; i > 0; i -= 0.4) ctx.fillText(text, Lo.x, Lo.y + i);

    fctx.setTransform(1, 0, 0, 1, 0, 0); fctx.globalCompositeOperation = 'source-over'; fctx.clearRect(0, 0, face.width, face.height);
    fctx.setTransform(DPR, 0, 0, DPR, 0, 0); fctx.font = font; fctx.textBaseline = 'alphabetic';
    var g = fctx.createLinearGradient(0, t, 0, b);
    pal.face.forEach(function (s) { g.addColorStop(s[0], s[1]); });
    fctx.fillStyle = g; fctx.fillText(text, Lo.x, Lo.y);
    fctx.globalCompositeOperation = 'source-atop';
    var sh = fctx.createLinearGradient(Lo.ink.l, t, Lo.ink.r, b);
    sh.addColorStop(0, 'rgba(255,255,255,0)'); sh.addColorStop(0.34, 'rgba(255,255,255,0)'); sh.addColorStop(0.45, pal.sheen);
    sh.addColorStop(0.56, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(255,255,255,0)');
    fctx.fillStyle = sh; fctx.fillRect(Lo.ink.l - 20, t - 20, Lo.ink.r - Lo.ink.l + 40, b - t + 40);
    rimLayer(text, Lo, font, pal.hi, bw, bw);
    rimLayer(text, Lo, font, pal.lo, -bw, -bw);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(face, 0, 0);
    ctx.restore();
  }

  var loaded = {};
  function loadFont(v) {
    var fam = family(v);
    if (!loaded[fam]) loaded[fam] = (document.fonts && document.fonts.load ? document.fonts.load('60px "' + fam + '"', 'AaEeYy') : Promise.resolve())
      .then(function () { return true; }, function () { return true; });
    return loaded[fam];
  }
  var token = 0;
  function draw() {
    var t = ++token, v = S.font, f = metal(), n = finalName(), text = n || SAMPLE;
    if (root.getAttribute('data-metal') !== f) root.setAttribute('data-metal', f);   // the birthstone settings follow the metal
    loadFont(v).then(function () {
      if (t !== token || !setup()) return;
      var fam = family(v);
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      plate(text, fam, layout(text, fam, fscale(v)), PAL[f]);
      root.classList.toggle('is-sample', !n);
      cv.setAttribute('aria-label', (n ? 'Font preview of "' + n + '"' : 'Sample font preview') + ' in ' + v + ', ' + finishValue());
    });
  }

  /* ---------- keep everything in step ---------- */
  function update() {
    if (countEl) countEl.textContent = S.name.length + '/' + MAX;
    syncProps(); draw();
  }
  /* the theme switches the variant (finish, or a font change from elsewhere): follow it */
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) return;
    if (t.matches('fieldset[data-handle="' + CFG.finishOpt + '"] input')) setTimeout(draw, 30);
    else if (t.matches('fieldset[data-handle="' + CFG.fontOpt + '"] input') && t.checked && t.value !== S.font && CFG.families[t.value]) { S.font = t.value; markRows(); draw(); }
  });

  /* the name (and the birthstone or birth flower, where there is one) is required before Add to bag / Buy it now;
     everything still missing is marked, and the page goes to the first one */
  function guard(e) {
    var form = productForm(); if (!form) return;
    var missing = picks.filter(function (P) { return !P.value; });
    if (finalName() && !missing.length) { unzep(); syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var b = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"], [data-add-to-cart]');
      if (!b) return;
      if (!form.contains(b) && b.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    var first = null;
    function earlier(a, b) { return !b || (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING); }
    missing.forEach(function (P) {
      pickError(P, 'Please choose a ' + P.noun + '.');
      setOpen(P, true);
      if (earlier(P.el, first)) first = P.el;
    });
    if (!finalName()) {
      root.classList.add('is-invalid');
      errEl.textContent = 'Please type the name or word for your ' + (CFG.item || 'piece') + '.';
      errEl.hidden = false;
      if (earlier(inp, first)) first = inp;
    }
    if (first === inp) {
      inp.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { inp.focus({ preventScroll: true }); } catch (x) { inp.focus(); }
    } else {
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      window.scrollTo({ top: Math.max(0, first.getBoundingClientRect().top + window.pageYOffset - hh - 16), behavior: 'smooth' });
    }
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme refreshes parts of the product area on variant change; keep our order details in the form */
  var moT;
  new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () { unzep(); syncProps(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  var rsT, lastW = 0;
  function onResize() {
    clearTimeout(rsT);
    rsT = setTimeout(function () { var w = stage.clientWidth; if (w && w !== lastW) { lastW = w; draw(); } }, 60);
  }
  if (window.ResizeObserver) new ResizeObserver(onResize).observe(stage); else window.addEventListener('resize', onResize);

  /* start from the variant the page opened on */
  var tf = checked(CFG.fontOpt); if (tf && CFG.families[tf]) S.font = tf;
  markRows(); unzep(); update();
  /* the other fonts load quietly in the background, so tapping through them is instant */
  setTimeout(function () { Object.keys(CFG.families).forEach(function (v) { loadFont(v); }); }, 1200);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
})();
